<mat-card fxLayout="column" fxFill>
    <div fxFlex>
        <router-outlet></router-outlet>
    </div>
</mat-card>